export default __webpack_public_path__ + "static/media/Create schedule 2.e94b3cd2.png";